import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FaAppStoreIos, FaGooglePlay } from 'react-icons/fa';
import moment from 'moment';
import 'moment/locale/th';
import 'moment/locale/pt-br';

class LinksPage extends Component {
    changeLanguage = (lng) => {
        this.props.i18n.changeLanguage(lng);
    };

    getDate = () => {
        const userLang = this.props.i18n.language;
        console.log("Current language:", userLang);
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Normalize time
    
        let year = today.getFullYear();
        let month = today.getMonth();
    
        let firstMonday = this.getFirstMondayOfMonth(year, month);
        firstMonday.setHours(0, 0, 0, 0);
    
        const diffInMs = firstMonday - today;
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    
        if (diffInDays <= 2) {
        // Too close or already passed – move to next month
        month += 1;
        if (month > 11) {
            month = 0;
            year += 1;
        }
        firstMonday = this.getFirstMondayOfMonth(year, month);
        }
    
        const date = moment(firstMonday);
    
        const formattedEN = date.locale('en').format('MMMM Do');
        const formattedTH = date.locale('th').format('D MMMM');
        const formattedPT = date.locale('pt-br').format('D [de] MMMM');
    
        const formattedDate =
        userLang === 'pt-BR' ? formattedPT :
        userLang === 'th' ? formattedTH :
        formattedEN;
    
        return formattedDate;
    };
    
    getFirstMondayOfMonth = (year, month) => {
        let date = new Date(year, month, 1);
        const day = date.getDay();
        const offset = (day === 0) ? 1 : ((8 - day) % 7);
        date.setDate(date.getDate() + offset);
        return date
    };

    render() {
        const { t, i18n } = this.props;

        return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="min-h-screen bg-black text-white flex flex-col items-center px-4 pt-10 pb-6"
        >
            {/* Language Selector */}
            <div className="absolute top-4 right-4">
            <select
                value={i18n.language}
                onChange={(e) => this.changeLanguage(e.target.value)}
                className="bg-gray-800 text-white rounded-md px-3 py-1 text-sm border border-gray-700 focus:outline-none"
            >
                <option value="en">EN</option>
                <option value="pt-BR">PT</option>
                <option value="th">TH</option>
            </select>
            </div>

            {/* Profile Image */}
            <motion.img
            src="/assets/coach-photo.jpg"
            alt="Diego Trainer"
            className="w-28 h-28 rounded-full border-4 border-white shadow-md"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ type: 'spring', stiffness: 200, delay: 0.3 }}
            />

            {/* Name and Bio */}
            <motion.h1
            className="text-3xl font-bold mt-5"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            >
            Diego Trainer
            </motion.h1>
            <motion.p
            className="text-sm text-gray-400 mt-2 text-center max-w-xs"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            >
            {t('bio')}
            </motion.p>

            {/* Link Buttons */}
            <div className="mt-10 w-full max-w-sm space-y-5">
            {/* 1-on-1 Coaching */}
            <motion.a
                href="https://www.diegotrainer.com"
                target="_blank"
                rel="noopener noreferrer"
                className="block bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-700 hover:to-blue-600 text-white text-center py-4 px-5 rounded-2xl shadow-lg"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.7 }}
            >
                <div 
                    className="text-lg text-center font-semibold"
                    dangerouslySetInnerHTML={{ __html: t('links.coaching') }}
                />
                {/* <div className="text-xs text-gray-200 mt-1">
                {t('links.coachingTrial')}
                </div> */}
            </motion.a>

            {/* Challenge */}
            <motion.a
                href="https://training-app.short.gy/train-with-diego-trainer"
                target="_blank"
                rel="noopener noreferrer"
                initial={{ boxShadow: '0 0 0px rgba(255, 0, 0, 0)' }}
                animate={{ boxShadow: '0 0 25px rgba(239, 68, 68, 0.6)' }}
                transition={{ duration: 1.2, ease: 'easeOut', delay: 0.9 }}
                className="block bg-gradient-to-r from-red-600 to-red-500 hover:from-red-700 hover:to-red-600 text-white text-center py-4 px-5 rounded-2xl font-bold shadow-xl"
            >
                <div
                    className="text-lg text-center"
                    dangerouslySetInnerHTML={{ __html: t('links.challenge') }}
                />
                <div className="text-xs text-gray-200 mt-1">
                {t('links.nextChallengeDate', {date: this.getDate()})}
                </div>
            </motion.a>

            {/* App Download */}
            <motion.a
                // href="https://yourapp.com"
                // target="_blank"
                // rel="noopener noreferrer"
                className="block bg-gradient-to-r from-green-500 to-green-600 text-white text-center py-5 px-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 1.1, type: "spring", damping: 10 }}
                >
                <div className="space-y-4">
                    <h3 className="text-xl font-bold tracking-tight">{t('links.app')}</h3>
                    
                    <div className="flex justify-center gap-3">
                    <motion.a
                        href="https://play.google.com/store/apps/details?id=app.dttrainingapp"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 bg-gray-900 hover:bg-gray-800 text-white px-4 py-2.5 rounded-lg transition-colors duration-200"
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <FaGooglePlay className="text-xl" />
                        <span className="text-sm font-medium">Google Play</span>
                    </motion.a>
                    
                    <motion.a
                        href="https://apps.apple.com/br/app/dt-training-app/id1550242297"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 bg-gray-900 hover:bg-gray-800 text-white px-4 py-2.5 rounded-lg transition-colors duration-200"
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        <FaAppStoreIos className="text-xl" />
                        <span className="text-sm font-medium">App Store</span>
                    </motion.a>
                    </div>
                </div>
                </motion.a>
            </div>

            {/* Footer */}
            <motion.footer
            className="mt-auto py-6 text-xs text-gray-500"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.4 }}
            >
            © {new Date().getFullYear()} DiegoTrainer.com
            </motion.footer>
        </motion.div>
        );
    }
}

export default withTranslation()(LinksPage);
